<template>
  <div class="yxtbiz-area-selector">
    <!-- 选择树区域 -->
    <div class="yxtbiz-area-selector__left">
      <AreaTree :list.sync="value"></AreaTree>
    </div>
    <!-- 已选区域 -->
    <div class="yxtbiz-area-selector__right">
      <CheckedAreas :list.sync="value" :limit="limit"></CheckedAreas>
    </div>
  </div>
</template>

<script>
/**
 * @description  : 选择区域组件
 * @date         : 2022-07-08 16:20:18
 * @author       : yokiizx
 * @example      : <yxtbiz-area-selector ref="areaSelector" v-model="list">
 */
// import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
import AreaTree from './components/AreaTree.vue';
import CheckedAreas from './components/CheckedAreas.vue';

export default {
  name: 'YxtbizAreaSelector',
  components: {
    AreaTree,
    CheckedAreas
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 1000
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  watch: {
    value(newVal) {
      this.$emit('update', newVal);
    }
  },
  methods: {
    validLimit() {
      return new Promise((resolve, reject) => {
        if (this.value.length > this.limit) {
          this.$message.warning(
            this.$t('pc_biz_area_limit', [this.limit]).d(
              `区域数量不能超过${this.limit}`
            )
          );
          return reject('exceed the limit');
        } else {
          return resolve();
        }
      });
    }
  }
};
</script>
